import * as T from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';
export const TooltipProvider = T.Provider;
export function Tooltip({ content, children }: { content: ReactNode; children: ReactNode }) {
  return (
    <T.Root delayDuration={300}>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content sideOffset={6} className="z-50 rounded-md border border-border bg-surface px-2 py-1 text-xs text-fg shadow-pop">
          {content}
          <T.Arrow className="fill-surface" />
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
